<style lang='scss'>
	#main-handhomes{
		.ant-select-selection{
			color: #000;
			background-color: #fff;
		}
		 .ant-input-disabled {
		    color: #000;
		    background-color: #fff;
		}
		.has-error .ant-form-explain, .has-error .ant-form-split{
			display: none;
		}
		.ant-form-inline .ant-form-item-with-help {
		    margin-bottom: 0;
		}
		.ant-form label{
			font-size: .8rem;
		}
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#tubody-mainsk1>div{
		padding: 1px 0;
	}
	
	#tubody-mainsk1{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			min-height: 12rem;
			max-height: 36rem;
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}

</style>
<template>
	<div>
		<a-modal
		:width='island=="handhome3"?"65rem":"55rem"'
		id='main-handhomes'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: island=='handhome3'?'6vh':island=='handhome2'?'12vh':'15vh'}"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;">{{ipoAduitAdmin?"新股審核":record.iposelling_id||form.iposelling_id?"新股編輯":"新股添加"}}</div>
			</div>
			<div style="display: flex;">
				<!-- (itemobj.schedule == 4 && itemobj.status == 0 && !itemobj.aduit)||(itemobj.status == 2)?titlearr1: -->
				<div v-for='(item,ind) in form.status_cn == 0?titlearr1:titlearr' 
				:key='ind + "0716"' v-if='!item.ishand'
				:class='island == item.component?"wland":"gland"' @click="fanfn(item)">
					{{item.name}}</div>
				<!-- <div style="margin-left: auto;font-size: 0.8rem;padding: 0.6rem 0;color: #000000;"
				>邀請編號 : </div> -->
			</div>
			<div id='tubody-mainsk1'>
				<component :is='island' :aduits='aduit' :ref='island' :applyid='applyid' @child="handchild" :record='record'
				 :forms='form' :missionflag="missionflag" @childs="isval"></component>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import handhome1 from './handhome1.vue'
	import handhome2 from './handhome2.vue'
	import handhome3 from './handhome3.vue'
	import handhome4 from './handhome4.vue'
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
		
	export default {
		name:'handhome',
		props:['itemobj','applyid','forms','record','missionflag'],
		components:{
			handhome1,handhome2,handhome3,handhome4
			},
		data(){
			return {
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				aduit:true,
				tableData:[],
				picList:[],
				isname: '申請假期',
				visible:true,
				island: 'handhome1',
				form: {
					"pricelist":[
					   // {"pricekey":"",
					   //  "priceval":"" 
					   // },
					  ],
					info_en:'',
					stockname_en: '', //股票名稱英文
					cn_planned_company_name_en: '', //公司名稱英文 
					cn_planned_industry_name_en: '', //行業英文 
					"stockcode": "", //輸入股票代碼
					"stockname": "", //輸入股票名稱
					"offer_price_l": '', //招股價起始值
					"offer_price_h": '', //招股價最大值
					"pergshu": '', //每手股數
					"application_open": "", //認購日期起始
					"application_close": "", //認購日期截止
					"listingdate": "", //上市日期
					"entryfee": '', //入場費
					"cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					"status_cn": "0", //上市狀態   已上市 （股票名称 股票代码）
					"plates_cn": "", //上市板塊
					"delivery_date": "", //遞表日期
					"baojianr": "", //保薦機構
					"anpantime": "", //暗盤時間
					"multiple": '', //認購倍數
					info: '',
					baojianr_en:'',
					linkaddress:'',
					pricefileid :'',
					loan_ratio :'',	// 比率
					loan_days :'',	// 日數
					gain :'',		// 利息
					// "adminid": "", // 錄入人唯一標識
				},
				titlearr1:[
					{
						name:'公司信息',
						component:'handhome1',
						island:false,
						// ishand:true
					}],
				titlearr:[
					{
						name:'公司信息',
						component:'handhome1',
						island:true
					},
					{
						name:'股票信息',
						component:'handhome2',
						island:false
					},
					{
						name:'金額表',
						component:'handhome3',
						island:false
					},{
						name:'孖展',
						component:'handhome4',
						island:false,
						// ishand:true
					},
				]
			}
		},
		created() {
			// let _this = this
			// setTimeout(()=>{
			// 	if(_this.itemobj.status == 2||(_this.itemobj.schedule == 4 && _this.itemobj.status == 0 && !_this.itemobj.aduit)){
			// 		_this.island = 'handitemjiaban'
			// 	}
			// },100)
		},
		mounted() {
			if(this.record.iposelling_id){
				this.moreEvent();
			}
		},
		watch:{
			// itemobj:{
			// 	deep:true,
			// 	immediate:true,
			// 	handler(ev){}
			// },
		},
		methods:{
			handchild(ev,id){
				let _this = this
				if(ev=='save'){
					setTimeout(()=>{
						_this.moreEvent(id);
					},100)
				} else if(ev){
					this.isval()
					setTimeout(()=>{
						_this.island = ev
					},100)
					/*
					let numarr = JSON.parse(JSON.stringify(this.fouten))
					let brr=[];
					for(let key in numarr){
						numarr[key].map((val,i)=>{
						if(val['pricekey']){
							val['pricekey'] = val['pricekey'].split(',').join('')
							if(val['priceval']){
								val['priceval'] = val['priceval'].split(',').join('')
									brr.push(val)   
							}
						}
					})
					}
					this.form.pricelist = brr;
					*/
				}else{
					this.$emit('child', 1)
				}
			},
			isval(){
				if(this.island == "handhome3"){
					// this.form.pricelist = this.$refs[this.island].fouten
					let numarr = JSON.parse(JSON.stringify(this.$refs[this.island].fouten))
					let brr=[];
					for(let key in numarr){
						numarr[key].map((val,i)=>{
						if(val['pricekey']){
							val['pricekey'] = val['pricekey'].split(',').join('')
							if(val['priceval']){
								val['priceval'] = val['priceval'].split(',').join('')
									brr.push(val)   
							}
						}
					})
					}
					this.form.pricelist = brr;
				}else{
					this.form = JSON.parse(JSON.stringify(this.$refs[this.island].form))
				}
			},
			moreEvent(id){
			    this.$ajax({
			    	method: 'post',
			    	url: this.$api.getIpoSellingById,
			    	headers: {
			    		token: this.$store.state.token
			    	},
			    	data: {
			    		"iposelling_id": id || this.record.iposelling_id,
						// this.missionflag?this.record.iposelling_id:id||this.record.iposelling_id,
			    		missionflag:this.missionflag
			    	}
			    }).then(res => {
			    	if (res.data.qmiscode === 1000) {
			    		let arr = {}
			    		// arr = res.data.iposelling
			    		// arr['pricelist'] = []
			    		this.form = res.data.iposelling
						// this.form['pricelist'] = res.data.iposelling
			    		// if(this.form.status_cn == 0){
			    		// 	this.statered = 1
			    		// }else if(this.form.status_cn == 3){
			    		// 	this.statered = 3
			    		// }else if(this.form.status_cn){
			    		// 	this.statered = 2
			    		// }
			    		// this.handselefn(this.form.status_cn,"ruleForm")
			    		// this.getdata()
			    	}else{
			    		App.oTool.warningT(res.data.qmismsg);
			    	}
			    })
			},
			// handselefn(val, ruleForm) {
			// 	if (val == 0) {
			// 		this.rules = this.zerorules
			// 	} else if (val == 1 || val == 2) {
			// 		this.rules = this.allrules
			// 	} else if (val == 3) {
			// 		this.rules = this.stockrules
			// 	}
			// 	let obj = JSON.parse(JSON.stringify(this.form))
			// 	this.$refs[ruleForm].resetFields();
			// 	this.form = obj
			// },
			fanfn(item){
				if(this.island == "handhome1"){
					this.$refs[this.island].gofn()
				}else 
				if(this.island == "handhome2"){
					this.$refs[this.island].gopagefn()
				}
				
				 this.isval()
				let _this = this
				 setTimeout(()=>{
					_this.island = item.component;
				},100)	
			},
			
			getdata(ev){
				this.$ajax({
					method:'post',
					url:this.$api.IpoPrice,
					data:{
						"iposelling_id":this.record.iposelling_id,
						missionflag:this.missionflag
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						let obj = {}
						obj = ev
						obj['pricelist'] = []
						res.data.pricelist.map(ev=>{
							obj['pricelist'].push(ev)
						})
						this.form = obj
						this.island == "handhome1"
					}
				})
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)
			},
		}
	}
</script>
